import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearchFilterMd = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.8748 21.3766L13.2248 14.7266C12.7415 15.1266 12.1665 15.4432 11.4998 15.6766C10.8331 15.9099 10.1248 16.0266 9.3748 16.0266C7.49147 16.0266 5.90397 15.3766 4.6123 14.0766C3.32064 12.7766 2.6748 11.2099 2.6748 9.37656C2.6748 7.54323 3.3248 5.97656 4.6248 4.67656C5.9248 3.37656 7.49147 2.72656 9.3248 2.72656C11.1748 2.72656 12.7415 3.37656 14.0248 4.67656C15.3081 5.97656 15.9498 7.54323 15.9498 9.37656C15.9498 10.1099 15.8415 10.8016 15.6248 11.4516C15.4081 12.1016 15.0831 12.7182 14.6498 13.3016L21.3248 19.9266L19.8748 21.3766ZM9.3498 14.0266C10.6331 14.0266 11.7248 13.5724 12.6248 12.6641C13.5248 11.7557 13.9748 10.6599 13.9748 9.37656C13.9748 8.09323 13.5248 6.9974 12.6248 6.08906C11.7248 5.18073 10.6331 4.72656 9.3498 4.72656C8.03314 4.72656 6.92064 5.18073 6.0123 6.08906C5.10397 6.9974 4.6498 8.09323 4.6498 9.37656C4.6498 10.6599 5.10397 11.7557 6.0123 12.6641C6.92064 13.5724 8.03314 14.0266 9.3498 14.0266Z",
		fill: "#3C59F6"
	})
});
export default SvgSearchFilterMd;
